import "./MenuAppSettings.scss"

import DefaultBoundaries from "@/app/boundaries/DefaultBoundaries"
import { EventDto } from "@/entities/app/menu/menu.dto"
import { MenuAppInstance } from "@/entities/app/menu/menu.types"
import DesignDAO from "@/entities/design/design.dao"
import Modal from "@/services/Modal/Modal"
import TextBox from "@/shared/layouts/TextBox/TextBox"

import PopupConfirmEventDelete from "../../modals/PopupConfirmEventDelete"
import PopupCreateEvent from "../../modals/PopupCreateEvent"
import MenuEventsList from "../MenuEventsList/MenuEventsList"



const designDao = new DesignDAO()

interface MenuAppSettingsProps {
  app: MenuAppInstance
  onCreateEvent?(event: EventDto): void | Promise<void>
  onUpdateEvent?(index: number, event: EventDto): void | Promise<void>
  onDeleteEvent?(index: number): void | Promise<void>
}

function MenuAppSettings(props: MenuAppSettingsProps) {
  function onCreateEvent() {
    Modal.open(PopupCreateEvent, {
      app: props.app,
      onSubmit: props.onCreateEvent
    })
  }

  async function onEditEvent(index: number) {
    const event = props.app.events?.[index]
    if (!event) return

    // Fetch the design if the event has a designId
    let defaultDesign = null
    if (event.designId) {
      try {
        defaultDesign = await designDao.findById(event.designId)
      } catch (error) {
        console.error("Failed to fetch design:", error)
        // Continue without design if fetch fails
      }
    }

    Modal.open(PopupCreateEvent, {
      app: props.app,
      defaultValue: event,
      defaultDesign,
      onSubmit: (updatedEvent) => props.onUpdateEvent?.(index, updatedEvent)
    })
  }

  function onDeleteEvent(index: number) {
    const event = props.app.events?.[index]
    if (!event) return

    Modal.open(PopupConfirmEventDelete, {
      event,
      onSubmit: () => props.onDeleteEvent?.(index)
    })
  }

  return (
    <div className="menu-app-settings">
      <TextBox>
        <h3>{props.app?.label || props.app.name}</h3>
        <p>{props.app.name}</p>
      </TextBox>
      <DefaultBoundaries>
        <MenuEventsList
          events={props.app.events ?? []}
          companyId={props.app.companyId}
          onCreate={onCreateEvent}
          onEdit={onEditEvent}
          onDelete={onDeleteEvent}
        />
      </DefaultBoundaries>
    </div>
  )
}

export default MenuAppSettings
